import React from 'react';
import styled from 'styled-components';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import { TransitionGroup } from 'react-transition-group';

const DetailsPanel = (props: React.PropsWithChildren) => {
    return (
        <FloatingEl>
            <TransitionGroup>
                <Slide direction={'up'}>
                    <Paper>{props.children}</Paper>
                </Slide>
            </TransitionGroup>
        </FloatingEl>
    );
};

const FloatingEl = styled.div`
    z-index: 1;
    pointer-events: none;
    background-color: transparent;
    padding: 4px;
    grid-column: sidebar-end / page-end;
    grid-row: timeline-top / timeline-bottom;
    justify-self: center;
    min-width: 900px;

    /* Allow pointer events only on child elements */
    & > * {
        pointer-events: all;
    }

    @media (max-width: 1452px) {
        grid-column: sidebar-start / page-end;
        padding: 0 8px 8px 8px;
        justify-self: flex-start;
        width: 100%;
    }
`;

export default DetailsPanel;
